import client from "./client";

export const login = async (
  username: string,
  password: string
): Promise<any> => {
  return await client
    .post("/auth/login", { username, password })
    .then(response => response.data.response);
};
